export const DesktopBreakPoint = 1024;
export const PostCodeKey = 'jWXlfQAccf39XvVVFbl0Wvis8pJTk0X2nmQLFHkd';
export const PostCodeRegex = /^[A-Z]{1,2}[0-9]{1,2} ?[0-9][A-Z]{2}$/i;